<script setup lang="ts">
import emblaCarouselVue from 'embla-carousel-vue'
import type { EmblaPluginType, EmblaOptionsType } from 'embla-carousel'

type Props = {
  options?: EmblaOptionsType;
  plugins?: Array<EmblaPluginType>;
}

const model = defineModel({ default: 0 })

const { plugins = [], options = {} } = defineProps<Props>()

const [carousel, carouselApi] = emblaCarouselVue({
  startIndex: model.value,
  ...options
}, plugins)

const next = () => carouselApi.value?.scrollNext()
const prev = () => carouselApi.value?.scrollPrev()
const canNext = () => carouselApi.value?.canScrollNext()
const canPrev = () => carouselApi.value?.canScrollPrev()

const onSelect = () => {
  model.value = carouselApi.value?.selectedScrollSnap() || 0
  carouselApi.value?.scrollTo(carouselApi.value?.selectedScrollSnap())
}

watch(model, (index: number) => {
  carouselApi.value?.scrollTo(index)
})

watchEffect(() => {
  if (!carouselApi.value) return
  onSelect()

  carouselApi.value.on('select', onSelect).on('reInit', onSelect)
})

defineExpose({
  carousel,
  carouselApi
})
</script>

<template>
  <div>
    <div class="overflow-hidden" ref="carousel">
      <div class="flex items-start touch-pan-y touch-pinch-zoom flex-row ml-[calc(var(--slide-spacing,0)*-1)] [transition:height_100ms_ease-in-out]">
        <slot />
      </div>
    </div>
    <slot name="addons" v-bind="{ prev, next, canPrev, canNext }" />
  </div>
</template>